"use client";
import { useState, useEffect, type MutableRefObject } from "react";
import { type mousePositionType } from "../types";

export function useMouseOffset(ref: MutableRefObject<HTMLElement> | any) {
  const [mouseOffset, setMouseOffset] = useState<mousePositionType>({
    x: null,
    y: null,
  });

  useEffect(() => {
    if (!ref || !ref?.current) {
      console.error("There is no element.");
      return;
    }

    const element = ref.current;
    const updateMouseOffset = (event: MouseEvent | any) => {
      setMouseOffset({ x: event.offsetX, y: event.offsetY });
    };

    element.addEventListener("mousemove", updateMouseOffset);

    return () => {
      element.removeEventListener("mousemove", updateMouseOffset);
    };
  }, [ref]);

  return mouseOffset;
}
